import { apiService } from './apiService';
import apiErrorHandler from '../../../services/apiErrorHandler';

type ApiResponse<T> = { success: boolean; data?: T; error?: string; status?: number };

const base = '/settings';

export async function getAll(publicOnly = true): Promise<ApiResponse<any[]>> {
  const qs = publicOnly ? '?public=true' : '';
  const res = await apiService.get<any[]>(`${base}${qs}`, true, {
    useCache: true,
    cacheTtlMs: 60_000,
    dedupe: true
  });
  const result = res as any;
  if (!result?.success) {
    apiErrorHandler.handleError(result || new Error('SETTINGS_GET_ALL_FAILED'), {
      autoRedirect: true,
      showNotification: false,
      context: 'SettingsAPI.getAll'
    });
  }
  return result;
}

export async function get(key: string): Promise<ApiResponse<any>> {
  const res = await apiService.get<any>(`${base}/${encodeURIComponent(key)}`, true, {
    useCache: true,
    cacheTtlMs: 60_000,
    dedupe: true
  });
  const result = res as any;
  if (!result?.success) {
    apiErrorHandler.handleError(result || new Error('SETTINGS_GET_FAILED'), {
      autoRedirect: true,
      showNotification: false,
      context: 'SettingsAPI.get'
    });
  }
  return result;
}

export async function set(key: string, value: any, is_public = true, description = ''): Promise<ApiResponse<any>> {
  const res = await apiService.post<any>(`${base}`, { key, value, is_public, description }, true);
  const result = res as any;
  if (!result?.success) {
    apiErrorHandler.handleError(result || new Error('SETTINGS_SET_FAILED'), {
      autoRedirect: true,
      showNotification: true,
      context: 'SettingsAPI.set'
    });
  }
  // Invalidate caches for settings endpoints so new values are fetched next time
  try {
    // Specific key endpoint
    apiService.invalidateGetCache(`${base}/${encodeURIComponent(key)}`);
    // List endpoint (public only cache as used by UI)
    apiService.invalidateGetCache(`${base}?public=true`);
  } catch {}
  return result;
}
